<template>
  <label class="clearfix">
    <div class="srh_form_l">{{ label }}</div>
    <div class="srh_form_r"><input type="text" :name="inputName" :value="textValue" class="form_control" readonly /></div>
  </label>

</template>

<script>
import {defineComponent, computed} from 'vue'

export default defineComponent({
  name: 'TextFormParts',
  props: {
    label: {
      type: String,
      default: '',
      required: true,
    },
    inputName: {
      type: String,
      default: '',
      required: true,
    },
    value: {
      type: String,
      default: '',
      required: true,
    },
  },
  setup(props) {
    const textValue = computed(() => props.value)

    return {
      textValue
    }
  },
})

</script>